
const state = {
  user: {
    id: null,
    info: {
      username: null,
      email: null,
      full_name: null,
      first_name: null,
      last_name: null
    },
  }
}


export default state
